package app.smartcoding.realrate.presentation.components

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import app.smartcoding.realrate.domain.model.CreditRating
import app.smartcoding.realrate.localization.LocalStrings
import app.smartcoding.realrate.presentation.util.formatNumber
import io.github.koalaplot.core.util.ExperimentalKoalaPlotApi

@Composable
@OptIn(ExperimentalKoalaPlotApi::class)
fun Result2(
    principal: Double,
    monthsValue: Int,
    paymentValue: Double,
) {
    val totalPayment = paymentValue * monthsValue
    val totalInterest = (totalPayment - principal).coerceAtLeast(0.0)

    Card(
        modifier = Modifier.fillMaxWidth().height(248.dp),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceContainerLow),
    ) {
        Column(modifier = Modifier.padding(16.dp)) {
            Text(
                text = LocalStrings.current.costOfCredit,
                style = MaterialTheme.typography.titleMedium,
                modifier = Modifier.padding(bottom = 16.dp)
            )
            CreditCostChart(totalPayment, principal)
            Spacer(modifier = Modifier.height(16.dp))
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                Column {
                    Text(LocalStrings.current.principal, style = MaterialTheme.typography.labelMedium)
                    Text(
                        text = principal.formatNumber(),
                        style = MaterialTheme.typography.bodyLarge,
                        color = CreditRating.EXCELLENT.color
                    )
                }
                Column(horizontalAlignment = Alignment.End) {
                    Text(
                        text = LocalStrings.current.interest,
                        style = MaterialTheme.typography.labelMedium
                    )
                    Text(
                        text = totalInterest.formatNumber(),
                        style = MaterialTheme.typography.bodyLarge,
                        color = CreditRating.BAD.color
                    )
                }
            }
            Spacer(modifier = Modifier.height(8.dp))
            HorizontalDivider()
            Spacer(modifier = Modifier.height(8.dp))
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                Text(LocalStrings.current.totalPaid, style = MaterialTheme.typography.titleMedium)
                Text(totalPayment.formatNumber(), style = MaterialTheme.typography.titleMedium)
            }
        }
    }
}

